import React, { useState } from 'react';
import Tremors from '../condition/Tremors';
import Mood from '../condition/Mood';
import Feeling from '../condition/Feeling';
import MyTabs from 'components/tabs/MyTabs';
import Header from 'components/navigation/Header';

export default function ConditionTabs() {
  const [currentTab, setCurrentTab] = useState(0);

  const tabList = ['Tremors','Mood','Feeling'];
  
  function onTabChange(n) {
    setCurrentTab(n);
  }

  return (
    <div className='mcard'>
      {/* <div className='mcard-screen'>Condition</div> */}
      <Header title='Condition' add={null} />
      <MyTabs tabList={tabList} currentTab={currentTab} onTabChange={onTabChange} />
      <>
      {currentTab === 0 && <Tremors />}
      {currentTab === 1 && <Mood />}
      {currentTab === 2 && <Feeling />}
      </>
    </div>
  );
}
